import React from 'react';

import { Route } from 'react-router-dom';

import { CreditCardPayment } from 'components/Payment/CreditCardPayment';
import { PaymentSuccessful } from 'components/Payment/PaymentSuccesful';

export interface IPaymentResponse {
    invoiceNumber: string,
    invoiceUrl: string
}

export const CheckoutRoute = () => {

    const [paymentSuccess, setPaymentSuccess] = React.useState<boolean>(false);

    const handlePaymentSuccess = () => {
        setPaymentSuccess(true);
    };

    // const handleClosePaymentSuccess = () => {
    //     setPaymentSuccess(false);
    // };

    return (
        <Route
            path="/payment"
            render={({match: {url}}) => (
                <>
                    {paymentSuccess ? (
                        <PaymentSuccessful/>
                    ) : (
                        // add handle payment success
                        <CreditCardPayment handlePaymentSuccess={handlePaymentSuccess}/>
                    )}
                </>
            )}
        />
    );
};
